import {
DEALERDASHBOARD_DATA_GET,
DEALERDASHBOARD_DATA_SUCCESS
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  dealerDashboardDetails: "",
}

const dealerDashboardGet = (state = initialState, action) => {
  switch (action.type) {
    case DEALERDASHBOARD_DATA_GET:
      state = {
        ...state,
        loading: true,
      }
      break
    case DEALERDASHBOARD_DATA_SUCCESS:
      state = {
        ...state,
        loading: false,
        isUserLogout: false,
        dealerDashboardDetails:action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default dealerDashboardGet


